import { render, staticRenderFns } from "./NotCompletedSnag.vue?vue&type=template&id=62c3cbcc&"
import script from "./NotCompletedSnag.vue?vue&type=script&lang=js&"
export * from "./NotCompletedSnag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports